var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { CloseWithoutBorder } from '../../../assets/images';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { FieldFailureReportsKeys } from '../services/entity';
import { Stack, useMediaQuery } from '@mui/material';
import { fieldFailureReportsWarrantyPartAPI } from '../services/apiCalls';
import { useAppSelector } from '../../../store/hooks';
import InfiniteScroll from '../../../builderPackage/components/infiniteScroll/infiniteScroll';
var WarrantyPartModal = function (_ref) {
    var _crud$FieldFailureRep, _crud$FieldFailureRep2;
    var onClose = _ref.onClose, data = _ref.data, id = _ref.id;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var hasMore = !crud[FieldFailureReportsKeys.GetWarrantyList] || ((_crud$FieldFailureRep = crud[FieldFailureReportsKeys.GetWarrantyList]) === null || _crud$FieldFailureRep === void 0 || (_crud$FieldFailureRep = _crud$FieldFailureRep.data) === null || _crud$FieldFailureRep === void 0 ? void 0 : _crud$FieldFailureRep.length) < ((_crud$FieldFailureRep2 = crud[FieldFailureReportsKeys.GetWarrantyList]) === null || _crud$FieldFailureRep2 === void 0 ? void 0 : _crud$FieldFailureRep2.count);
    var formMobileData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "PartName",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "IsCausal",
                                    label: 'Causal :',
                                    columnSize: 0,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: "inline-flex",
                                        alignItems: "baseline",
                                        gap: 1
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "PartCode",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    color: 'text.tertiary',
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "IsConsequential",
                                    label: 'Consequential :',
                                    columnSize: 0,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    containerProps: {
                                        display: "inline-flex",
                                        alignItems: "baseline",
                                        gap: 1
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }]
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            name: 'header',
            p: 2,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'headername',
                    children: 'Warrenty part details',
                    fontSize: 'xl',
                    fontWeight: 'strong',
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    label: '',
                    name: '',
                    value: null,
                    columnSize: 1,
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: CloseWithoutBorder
                    }),
                    onClick: function () {
                        onClose();
                    }
                }]
        }];
    var pagingColumns = [{
            field: "id",
            headerName: "Sr. no",
            width: 10,
            headerAlign: "center",
            align: "center",
            minWidth: 60
        }, {
            field: "PartCode",
            headerName: "Part code",
            headerAlign: "center",
            align: "center",
            minWidth: 60
        }, {
            field: "PartName",
            headerName: "Part name",
            headerAlign: "center",
            align: "center",
            minWidth: 180
        }, {
            field: "IsCausal",
            headerName: "Causal",
            headerAlign: "center",
            align: "center",
            minWidth: 60
        }, {
            field: "IsConsequential",
            headerName: "Consequential",
            headerAlign: "center",
            align: "center",
            minWidth: 60
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            padding: 3
        }
    }, lgMode ? /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: FieldFailureReportsKeys.GetWarrantyList,
        getPagingData: fieldFailureReportsWarrantyPartAPI,
        pagingAPIRequest: {
            id: id
        },
        columns: pagingColumns,
        dataGridProps: {
            initialState: {
                density: 'standard'
                // columns: data
            }
        }
    }) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiKey: FieldFailureReportsKeys.GetWarrantyList,
        apiCall: fieldFailureReportsWarrantyPartAPI,
        apiRequest: {
            id: id
        },
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 1,
            p: 1
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        },
        elements: formMobileData
    })));
};
export default WarrantyPartModal;
